import { ExternalLink } from "@/components/ExternalLink";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { CheckIcon } from "@radix-ui/react-icons";
import { ColumnDef } from "@tanstack/react-table";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
import { Tables } from "@/gen/tableNames/tables";
import { Clients } from "@/lib/clients";
import {
  buildSharedPortfolioColumns,
  withPortfolioActions,
} from "@/lib/portfolios/tableColumns";

// import { getAuditColumns } from "@/features/Audit/getAuditColumns";

export type A5Portfolio = {
  id: number;
  client: string;
  vehicle: string | null;
  account_name: string;
  short_account_name: string | null;
  name: string;
  currency: string;
  reporting_currency: string;
  bank_name: string | null;
  account_type: string;
  account_type_2: string | null;
  code: string;

  has_pdf_bank_page: boolean | null;
  display_performance_report: boolean | null;
  bank_connection: boolean | null;

  collateral: boolean | null;
  has_transactions?: boolean;

  vehicle_index: number | null;
};

export const columnVisibilityInit: Record<string, boolean> = {
};

const boolCell =
  () =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ getValue }: any) =>
    Boolean(getValue()) && (
      <div className="flex justify-center">
        <CheckIcon />
      </div>
    );

export const porfolios_columns: ColumnDef<A5Portfolio>[] = withPortfolioActions(
  buildSharedPortfolioColumns<A5Portfolio, unknown>({
    booleanCell: boolCell(),
    fields: {
      id: "id",
      client: "client",
      vehicle: "vehicle",
      reporting_currency: "reporting_currency",
      account_name: "account_name",
      name: "name",
      account_type: "account_type",
      currency: "currency",
      code: "code",
      bank_name: "bank_name",
      bank_connection: "bank_connection",
    },
  }),
  [
    {
      id: "actions",
      cell: ({ row }) => {
        const hasTransactions = row.original.has_transactions;

        return (
          <div className="flex gap-3 justify-end">
            <ExternalLink
              href={toWorkspacePath(
                `/admin/${Clients.A5}/${Tables.A5_TRANSACTIONS}`,
              )}
              queryParams={{ a5_portfolios_id_equal: row.getValue("id") }}
              className={`text-xs ${
                !hasTransactions ? "invisible pointer-events-none" : ""
              }`}
              underline="hover"
            >
              {i18n.t("actions.transactions")}
            </ExternalLink>
            <Link
              href={`${window.location.pathname}/${row.getValue("id")}`}
              className="text-xs"
              underline="hover"
            >
              {i18n.t("actions.edit")}
            </Link>
          </div>
        );
      },
    },
  ],
);

// export const porfolios_audit_columns = getAuditColumns<A5Portfolio>(porfolios_columns)
